import { FrontendLoad } from '@trucksmarter/shared';
import { DallasTableDataCell } from '~/app/_ui/Dallas/Table/DallasTable';
import DallasLinkButton from '@ui/Dallas/Buttons/DallasLinkButton/DallasLinkButton';

interface Props {
  className?: string;
  loadId: FrontendLoad['id'];
}

export default function ViewPublicLoadCell({ className, loadId }: Props) {
  return (
    <DallasTableDataCell className={className}>
      <DallasLinkButton
        href={`/load/${loadId}/public`}
        label="View load"
        target="_blank"
        size="small"
        color="brand"
      />
    </DallasTableDataCell>
  );
}
